export const SITE_DEFAULTS: Record<string, any> = {
  home: {
    hero: {
      titleLine1: "World Class Media",
      titleLine2: "For Real Estate",
      buttonText: "Book Now",
      videoUrl: "https://realta.b-cdn.net/Media/Hero%20Section%20Video%20WOv3.mp4",
      posterUrl: "https://realta.b-cdn.net/Media/Hero%20Section%20Fallback%20WO.jpg"
    },
    services: {
      photographyTitle: "Photography",
      photographyDesc: "Magazine-quality photos that makes spaces feel bright, open, and inviting.",
      photographyImg: "https://realta.b-cdn.net/Media/WO%20LM-NLP-Hero%20Image.avif",
      videoTitle: "Cinematic Video",
      videoDesc: "4K narratives that highlight the lifestyle and flow of a property, shot on cinema cameras.",
      videoUrl: "https://realta.b-cdn.net/Media/WO%201448%20Mannheim%20Rd%2C%20Wilmot%2C%20ON%20N0B%202H0.mp4",
      videoPoster: "https://realta.b-cdn.net/Media/WO%20FAllback%20Image%201448%20Mannheim%20Rd%2C%20Wilmot%2C%20ON%20N0B%202H0%20(1).jpg",
      brandingTitle: "Branding",
      brandingDesc: "Social-first content strategies to position you as the market expert and build your personal brand.",
      brandingImg: "https://realta.b-cdn.net/Media/WO%201x1%20Revel%20Office%20Presentation%20Vertical.jpg"
    },
    reels: {
      title: "Listing Reels",
      level1Title: "Level 1 - Basic Walkthrough",
      level1Desc: "Quick tour for social media. 30-45s vertical cut.",
      level1Video: "https://realta.b-cdn.net/Media/WO%20Level%201%20Doug%20Gordin%20Whitby%2C%20Ontariov2.mp4",
      level1Poster: "https://realta.b-cdn.net/Media/WO%20Leve%201%20-%20Example%201%20Fallback%20(1).jpg",
      level2Title: "Level 2 - Advanced Visuals",
      level2Desc: "High-end transitions & speed ramps. The ultimate scroll-stopper.",
      level2Video: "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON_prob4v2.mp4",
      level2Poster: "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON-thumbnail.jpg"
    },
    differentiate: {
      title: "Differentiate From Competitors. Build Trust.",
      video1Url: "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON_prob4v2.mp4",
      video1Poster: "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON-Fallback%20(1).jpg",
      video1Tag: "Level 2 Reel with Twilight add-on",
      video2Url: "https://realta.b-cdn.net/Media/WO%20Bar%20Bc%20Ranch%20Rd.mp4",
      video2Poster: "https://realta.b-cdn.net/Media/WO%20Bar%20Bc%20Ranch%20Rd%20Fallback%20(1).jpg",
      video2Tag: "Custom Cinematic Tour",
      counter1Value: 2000,
      counter1Label: "Properties Filmed",
      counter2Value: 300,
      counter2Label: "Happy Agents",
      counter3Value: 1,
      counter3Label: "Billion Sold ($) +",
      counter4Value: 5,
      counter4Label: "Years Active"
    },
    process: {
      title: "Our Process",
      description: "You need story-first media to captivate your audience, draw in buyers and get your listing sold. Schedule a discovery call today.",
      steps: [
        { step: "Step 1", title: "Book Your Shoot", desc: "Schedule your shoot online or by phone instantly.", icon: "MousePointerClick" },
        { step: "Step 2", title: "Select Package", desc: "Choose the services and add-ons you need.", icon: "LayoutTemplate" },
        { step: "Step 3", title: "Shoot Day", desc: "Our team arrives to capture your listing perfectly.", icon: "Camera" },
        { step: "Step 4", title: "Media Delivery", desc: "Receive your edited media in 1-2 business days.", icon: "Send" }
      ]
    },
    ready: {
      title: "Ready To Dominate?",
      description: "Schedule your shoot today and receive your photos the next morning.",
      buttonText: "Book Your Shoot"
    },
    appDownload: {
      title: "Download Our App",
      titleAccent: "Mobile App",
      description: "Instant bookings, media downloads and playback on demand, take control of your marketing from anywhere.",
      appStoreUrl: "https://apps.apple.com/ca/app/realta-media-agency/id6757725284",
      playStoreUrl: "#"
    }
  },
  'listing-media': {
    header: {
      label: "Our Services",
      titleLine1: "Listing",
      titleLine2: "Media",
      description: "Professional listing photos, videos, and content that showcase your vision to buyers before they even set foot on the property - so you sell homes faster, easier, and for more.",
      buttonText: "Book Now",
      videoUrl: "https://realta.b-cdn.net/Media/WO%20Hero%20Section%20Wagon%20Rd%202025.mp4",
      posterUrl: "https://realta.b-cdn.net/Media/WO%20Hero%20Section%20Fall%20Back%20Image%202025.jpg"
    },
    process: {
      title: "Our Process",
      label: "Seamless Flow",
      steps: [
        { step: "01", title: "Book", desc: "Schedule your shoot online or by phone instantly. We confirm within minutes.", icon: "MousePointerClick" },
        { step: "02", title: "Select", desc: "Choose the services and add-ons you need for your listing. Upgrades available.", icon: "LayoutTemplate" },
        { step: "03", title: "Shoot", desc: "Our team arrives to capture your listing perfectly. We handle all logistics.", icon: "Camera" },
        { step: "04", title: "Deliver", desc: "Receive your edited media in 1-2 business days. Ready for MLS upload.", icon: "Send" }
      ]
    },
    cinematic: {
      label: "Cinema Grade",
      title: "Cinematic Video Tours",
      description: "Our high-end cinematic tours are designed to tell a story, capturing the unique character and luxury of every home."
    },
    photography: {
      title: "Next Level Photography"
    },
    scared: {
      title: "Scared of camera?",
      description: "You wouldn’t believe how many times this happens when a new agent signs up with us. But you don’t have to worry - we do everything for you: preparing scripts, matching your vibe, getting you comfortable, and making sure your real personality shines through the camera so people can connect with you. We’re excited for you.",
      stat1Value: "300+",
      stat1Label: "Agents Helped",
      stat2Value: "5+ Yrs",
      stat2Label: "Expertise",
      stat3Value: "1B+",
      stat3Label: "Billions Filmed",
      buttonText: "Book your shoot"
    },
    level1: {
      label: "Social Ready",
      title: "Level 1: Walk-through Video",
      description: "Smooth speed ramps, high-end visuals – this is your polished walk-through that checks all the boxes and builds your brand with style, designed for Instagram and TikTok.",
      video1Url: "https://realta.b-cdn.net/Media/WO%2015%20Klimek%20Blvd-%20Without%20Agent.mp4",
      video1AltUrl: "https://realta.b-cdn.net/Media/WO%2015%20Klimek%20Blvd.mp4",
      video2Url: "https://realta.b-cdn.net/Media/WO%20Level%201%20-%20111%20Glenmore%20Rd%2C%20Toronto%2C%20ON%20M4L%203M2%20.mp4",
      video2Poster: "https://realta.b-cdn.net/Media/WO%20Level%201%20-%20111%20Glenmore%20Rd%2C%20Toronto%2C%20ON%20Fallback.jpg"
    },
    level2: {
      label: "Cinema Grade",
      title: "Level 2: Signature Video",
      description: "We bring the brains and the beauty. Scripted, directed, and designed for today’s algorithm - complete with sound design, cinematic colors, and visual effects that actually make sense. This isn't just another video; it makes you stand out from the crowd.",
      video1Url: "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON_prob4v2.mp4",
      video1Poster: "https://realta.b-cdn.net/Media/WO%20Winvillle%20Road%2C%20Pickering%20ON-Fallback%20(1).jpg",
      video2Url: "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON_prob4v2.mp4",
      video2Poster: "https://realta.b-cdn.net/Media/WO%20Level%202%201364%20Aymond%20Cres%2C%20Oakville%2C%20ON-thumbnail.jpg"
    }
  },
  'brand-media': {
    header: {
      titleLine1: "Brand",
      titleLine2: "Media",
      description: "Scale your personal brand with high-impact vertical video, cinematic bio films, and strategic social content that positions you as the local authority.",
      buttonText: "Book Free Discovery Call",
      videoUrl: "https://realta.b-cdn.net/Media/Hero%20Section%20Video%20WOv3.mp4",
      posterUrl: "https://realta.b-cdn.net/Media/Hero%20Section%20Fallback%20WO.jpg"
    },
    process: {
      title: "Our Process",
      label: "Seamless Flow"
    },
    bio: {
      label: "Storytelling",
      titleLine1: "The",
      titleLine2: "Agent Bio",
      videoUrl: "https://realta.b-cdn.net/Media/WO%20Agent%20Bio_prob4.mp4",
      posterUrl: "https://realta.b-cdn.net/Media/WO%20Agent%20Bio%20fallback.jpg",
      buttonText: "Book Free Discovery Call"
    },
    social: {
      label: "Visual Authority",
      titleLine1: "Social",
      titleLine2: "Packages",
      priceLabel: "Investment",
      price: "$800",
      priceSublabel: "Starting Price",
      packageName: "Monthly Growth Package",
      buttonText: "Book Free Discovery Call"
    }
  }
};
